import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/error-pages/500-page.scss';
import '../../css/pages/error-pages/title-error.scss';
import '../../css/pages/error-pages/description-error.scss';
import '../../css/pages/error-pages/error-code.scss';
import '../../css/pages/error-pages/error-span.scss';

registerPageInit('500-page', () => {});
